<template>
  <div id="fundo" class="grid grid-cols-12 py-6 px-6 max-w-5xl h-full mx-auto">
    <!-- class="col-span-12 border border-ontick-graphite-500 my-auto p-6 space-y-3" -->
    <div id="borda" class="col-span-12 my-auto space-y-3">
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <div class="flex space-x-2 py-1">
        <button
          @click="selectedPeriod = 'ANUAL'"
          :class="['button', selectedPeriod === 'ANUAL' && 'active']"
        >
          ANUAL
        </button>
        <button
          @click="selectedPeriod = 'JAN'"
          :class="['button', selectedPeriod === 'JAN' && 'active']"
        >
          JAN
        </button>
        <button
          @click="selectedPeriod = 'FEV'"
          :class="['button', selectedPeriod === 'FEV' && 'active']"
        >
          FEV
        </button>
        <button
          @click="selectedPeriod = 'MAR'"
          :class="['button', selectedPeriod === 'MAR' && 'active']"
        >
          MAR
        </button>
        <button
          @click="selectedPeriod = 'ABR'"
          :class="['button', selectedPeriod === 'ABR' && 'active']"
        >
          ABR
        </button>
        <button
          @click="selectedPeriod = 'MAI'"
          :class="['button', selectedPeriod === 'MAI' && 'active']"
        >
          MAI
        </button>
        <button
          @click="selectedPeriod = 'JUN'"
          :class="['button', selectedPeriod === 'JUN' && 'active']"
        >
          JUN
        </button>
        <button
          @click="selectedPeriod = 'JUL'"
          :class="['button', selectedPeriod === 'JUL' && 'active']"
        >
          JUL
        </button>
        <button
          @click="selectedPeriod = 'AGO'"
          :class="['button', selectedPeriod === 'AGO' && 'active']"
        >
          AGO
        </button>
        <button
          @click="selectedPeriod = 'SET'"
          :class="['button', selectedPeriod === 'SET' && 'active']"
        >
          SET
        </button>
        <button
          @click="selectedPeriod = 'OUT'"
          :class="['button', selectedPeriod === 'OUT' && 'active']"
        >
          OUT
        </button>
        <button
          @click="selectedPeriod = 'NOV'"
          :class="['button', selectedPeriod === 'NOV' && 'active']"
        >
          NOV
        </button>
        <button
          @click="selectedPeriod = 'DEZ'"
          :class="['button', selectedPeriod === 'DEZ' && 'active']"
        >
          DEZ
        </button>
      </div>
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- ++++++++++++++++++++++++++++++++++++++++++ -->
      <!-- <div class="flex flex-col space-y-2 overflow-x-scroll overflow-y-hidden py-1"> -->
      <div class="flex flex-col space-y-2 py-1">
        <!-- Meses -->
        <div class="flex justify-around">
          <div
            v-for="(month, key) in listMonths"
            :key="key"
            :class="['months', textColorMonth(month)]"
          >
            {{ month }}
          </div>
        </div>
        <div class="flex space-x-2">
          <!-- Dias -->
          <div class="grid grid-rows-7 grid-flow-col gap-0">
            <div v-for="(day, key) in listDays" :key="key" class="days">
              {{ day }}
            </div>
          </div>
          <!-- Heatmap -->
          <div class="grid grid-rows-7 grid-flow-col gap-0.5">
            <!-- <div class="grid grid-rows-7 grid-flow-col gap-[3px]"> -->
            <div
              v-for="item in data"
              :key="item[0]"
              :class="['boxHeatmap', boxColor(item)]"
              :content="boxTooltipContent(item)"
              v-tippy="{
                arrow: true,
                arrowType: 'round',
                animation: 'scale',
                theme: 'gray',
              }"
            >
              &nbsp;
            </div>
          </div>
        </div>
      </div>
      <div class="flex space-x-6">
        <p class="inline-flex items-center space-x-1.5">
          <span class="block w-3 h-3 rounded-sm bg-[#2D3748]"></span>
          <span class="text-xs font-semibold">Sem operação</span>
        </p>
        <p class="inline-flex items-center space-x-1.5">
          <span class="block w-3 h-3 rounded-sm bg-[#1EB866]"></span>
          <span class="text-xs font-semibold">Lucro</span>
        </p>
        <p class="inline-flex items-center space-x-1.5">
          <span class="block w-3 h-3 rounded-sm bg-[#DD5B5B]"></span>
          <span class="text-xs font-semibold">Perda</span>
        </p>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
export default {
  name: "heatmap",
  data() {
    return {
      count: 0,
      listDays: ["D", "S", "T", "Q", "Q", "S", "S"],
      listMonths: [
        "JAN",
        "FEV",
        "MAR",
        "ABR",
        "MAI",
        "JUN",
        "JUL",
        "AGO",
        "SET",
        "OUT",
        "NOV",
        "DEZ",
      ],
      data: [
        ["2023-01-01", 9773],
        ["2023-01-02", 5933],
        ["2023-01-03", 2863],
        ["2023-01-04", -8608],
        ["2023-01-05", 3507],
        ["2023-01-06", 0],
        ["2023-01-07", -3338],
        ["2023-01-08", 7709],
        ["2023-01-09", -6810],
        ["2023-01-10", -4558],
        ["2023-01-11", 0],
        ["2023-01-12", -4028],
        ["2023-01-13", 5497],
        ["2023-01-14", -9386],
        ["2023-01-15", 249],
        ["2023-01-16", 0],
        ["2023-01-17", -5834],
        ["2023-01-18", -8838],
        ["2023-01-19", -7516],
        ["2023-01-20", 4057],
        ["2023-01-21", 0],
        ["2023-01-22", -9316],
        ["2023-01-23", -9466],
        ["2023-01-24", -412],
        ["2023-01-25", -260],
        ["2023-01-26", 0],
        ["2023-01-27", 3171],
        ["2023-01-28", 6689],
        ["2023-01-29", -620],
        ["2023-01-30", 5353],
        ["2023-01-31", 0],
        ["2023-02-01", -3956],
        ["2023-02-02", -6616],
        ["2023-02-03", -4060],
        ["2023-02-04", -8388],
        ["2023-02-05", 0],
        ["2023-02-06", 3825],
        ["2023-02-07", -6436],
        ["2023-02-08", -6836],
        ["2023-02-09", -7688],
        ["2023-02-10", 0],
        ["2023-02-11", -6120],
        ["2023-02-12", 7031],
        ["2023-02-13", -7056],
        ["2023-02-14", 2701],
        ["2023-02-15", 0],
        ["2023-02-16", 4475],
        ["2023-02-17", -7968],
        ["2023-02-18", 2397],
        ["2023-02-19", 6855],
        ["2023-02-20", 0],
        ["2023-02-21", -3158],
        ["2023-02-22", 4457],
        ["2023-02-23", 8211],
        ["2023-02-24", -272],
        ["2023-02-25", 0],
        ["2023-02-26", -9648],
        ["2023-02-27", -2528],
        ["2023-02-28", 7033],
        ["2023-03-01", -8772],
        ["2023-03-02", 0],
        ["2023-03-03", -4630],
        ["2023-03-04", -9616],
        ["2023-03-05", 479],
        ["2023-03-06", -5076],
        ["2023-03-07", 0],
        ["2023-03-08", 8689],
        ["2023-03-09", 481],
        ["2023-03-10", 6309],
        ["2023-03-11", -974],
        ["2023-03-12", 0],
        ["2023-03-13", -5196],
        ["2023-03-14", 9765],
        ["2023-03-15", -3096],
        ["2023-03-16", 7005],
        ["2023-03-17", 0],
        ["2023-03-18", 8057],
        ["2023-03-19", -3014],
        ["2023-03-20", -2912],
        ["2023-03-21", -4620],
        ["2023-03-22", 0],
        ["2023-03-23", 5221],
        ["2023-03-24", 399],
        ["2023-03-25", -2492],
        ["2023-03-26", -8970],
        ["2023-03-27", 0],
        ["2023-03-28", -1672],
        ["2023-03-29", -9368],
        ["2023-03-30", -9496],
        ["2023-03-31", -5186],
        ["2023-04-01", 0],
        ["2023-04-02", 107],
        ["2023-04-03", 5223],
        ["2023-04-04", -1146],
        ["2023-04-05", -3954],
        ["2023-04-06", 0],
        ["2023-04-07", 6693],
        ["2023-04-08", -4464],
        ["2023-04-09", -9100],
        ["2023-04-10", 5019],
        ["2023-04-11", 0],
        ["2023-04-12", -5048],
        ["2023-04-13", -1730],
        ["2023-04-14", -1512],
        ["2023-04-15", 9283],
        ["2023-04-16", 0],
        ["2023-04-17", 2919],
        ["2023-04-18", -6422],
        ["2023-04-19", 7779],
        ["2023-04-20", 5701],
        ["2023-04-21", 0],
        ["2023-04-22", -7884],
        ["2023-04-23", -3694],
        ["2023-04-24", -3364],
        ["2023-04-25", -3726],
        ["2023-04-26", 0],
        ["2023-04-27", 2355],
        ["2023-04-28", -3952],
        ["2023-04-29", 5575],
        ["2023-04-30", -6388],
        ["2023-05-01", 0],
        ["2023-05-02", 3719],
        ["2023-05-03", -5104],
        ["2023-05-04", 5691],
        ["2023-05-05", -6376],
        ["2023-05-06", 0],
        ["2023-05-07", 6993],
        ["2023-05-08", -3088],
        ["2023-05-09", 1149],
        ["2023-05-10", -7588],
        ["2023-05-11", 0],
        ["2023-05-12", -8606],
        ["2023-05-13", 5937],
        ["2023-05-14", -3650],
        ["2023-05-15", 7167],
        ["2023-05-16", 0],
        ["2023-05-17", 3341],
        ["2023-05-18", 7097],
        ["2023-05-19", -4498],
        ["2023-05-20", -2188],
        ["2023-05-21", 0],
        ["2023-05-22", -3416],
        ["2023-05-23", -188],
        ["2023-05-24", 6823],
        ["2023-05-25", -1298],
        ["2023-05-26", 0],
        ["2023-05-27", -4186],
        ["2023-05-28", -4928],
        ["2023-05-29", -404],
        ["2023-05-30", -418],
        ["2023-05-31", 0],
        ["2023-06-01", -6522],
        ["2023-06-02", -4290],
        ["2023-06-03", -9356],
        ["2023-06-04", -5454],
        ["2023-06-05", 0],
        ["2023-06-06", 131],
        ["2023-06-07", 6907],
        ["2023-06-08", 3307],
        ["2023-06-09", -2984],
        ["2023-06-10", 0],
        ["2023-06-11", -4852],
        ["2023-06-12", 8641],
        ["2023-06-13", 3169],
        ["2023-06-14", -4508],
        ["2023-06-15", 0],
        ["2023-06-16", -9474],
        ["2023-06-17", 549],
        ["2023-06-18", -9326],
        ["2023-06-19", -2204],
        ["2023-06-20", 0],
        ["2023-06-21", 5345],
        ["2023-06-22", 2067],
        ["2023-06-23", 1085],
        ["2023-06-24", -6234],
        ["2023-06-25", 0],
        ["2023-06-26", 2509],
        ["2023-06-27", -9782],
        ["2023-06-28", -2664],
        ["2023-06-29", -3908],
        ["2023-06-30", 0],
        ["2023-07-01", 5915],
        ["2023-07-02", 8793],
        ["2023-07-03", 9283],
        ["2023-07-04", -5994],
        ["2023-07-05", 0],
        ["2023-07-06", -7334],
        ["2023-07-07", -7808],
        ["2023-07-08", 1679],
        ["2023-07-09", -7308],
        ["2023-07-10", 0],
        ["2023-07-11", -7692],
        ["2023-07-12", 7335],
        ["2023-07-13", -5444],
        ["2023-07-14", -3934],
        ["2023-07-15", 0],
        ["2023-07-16", 4327],
        ["2023-07-17", -6386],
        ["2023-07-18", -5708],
        ["2023-07-19", -6350],
        ["2023-07-20", 0],
        ["2023-07-21", 1195],
        ["2023-07-22", 255],
        ["2023-07-23", -154],
        ["2023-07-24", -4586],
        ["2023-07-25", 0],
        ["2023-07-26", 1209],
        ["2023-07-27", -5090],
        ["2023-07-28", 4041],
        ["2023-07-29", -3358],
        ["2023-07-30", 0],
        ["2023-07-31", 1037],
        ["2023-08-01", -1182],
        ["2023-08-02", 4401],
        ["2023-08-03", 1945],
        ["2023-08-04", 0],
        ["2023-08-05", -9582],
        ["2023-08-06", 1615],
        ["2023-08-07", -4078],
        ["2023-08-08", -1954],
        ["2023-08-09", 0],
        ["2023-08-10", 4285],
        ["2023-08-11", 595],
        ["2023-08-12", -4406],
        ["2023-08-13", -5674],
        ["2023-08-14", 0],
        ["2023-08-15", 4415],
        ["2023-08-16", 5529],
        ["2023-08-17", 57],
        ["2023-08-18", 5441],
        ["2023-08-19", 0],
        ["2023-08-20", 8991],
        ["2023-08-21", -5620],
        ["2023-08-22", 375],
        ["2023-08-23", -5054],
        ["2023-08-24", 0],
        ["2023-08-25", -4642],
        ["2023-08-26", 9693],
        ["2023-08-27", -6804],
        ["2023-08-28", -6604],
        ["2023-08-29", 0],
        ["2023-08-30", 1869],
        ["2023-08-31", -1046],
        ["2023-09-01", -3656],
        ["2023-09-02", 6645],
        ["2023-09-03", 0],
        ["2023-09-04", -6764],
        ["2023-09-05", 227],
        ["2023-09-06", -9850],
        ["2023-09-07", -4752],
        ["2023-09-08", 0],
        ["2023-09-09", -7720],
        ["2023-09-10", 7279],
        ["2023-09-11", -2718],
        ["2023-09-12", 2423],
        ["2023-09-13", 0],
        ["2023-09-14", -808],
        ["2023-09-15", 5369],
        ["2023-09-16", 8837],
        ["2023-09-17", 5447],
        ["2023-09-18", 0],
        ["2023-09-19", -52],
        ["2023-09-20", -4594],
        ["2023-09-21", -3364],
        ["2023-09-22", 597],
        ["2023-09-23", 0],
        ["2023-09-24", 4363],
        ["2023-09-25", 6619],
        ["2023-09-26", -3732],
        ["2023-09-27", -1992],
        ["2023-09-28", 0],
        ["2023-09-29", -4488],
        ["2023-09-30", -1182],
        ["2023-10-01", 3721],
        ["2023-10-02", -3874],
        ["2023-10-03", 0],
        ["2023-10-04", -1454],
        ["2023-10-05", -1702],
        ["2023-10-06", 5837],
        ["2023-10-07", -3160],
        ["2023-10-08", 0],
        ["2023-10-09", 5675],
        ["2023-10-10", 1785],
        ["2023-10-11", -592],
        ["2023-10-12", -5570],
        ["2023-10-13", 0],
        ["2023-10-14", 4141],
        ["2023-10-15", 8683],
        ["2023-10-16", -7318],
        ["2023-10-17", -7482],
        ["2023-10-18", 0],
        ["2023-10-19", -1958],
        ["2023-10-20", 5041],
        ["2023-10-21", -9504],
        ["2023-10-22", -7232],
        ["2023-10-23", 0],
        ["2023-10-24", 7935],
        ["2023-10-25", 983],
        ["2023-10-26", -8692],
        ["2023-10-27", 4857],
        ["2023-10-28", 0],
        ["2023-10-29", -5518],
        ["2023-10-30", -9378],
        ["2023-10-31", -6696],
        ["2023-11-01", 1417],
        ["2023-11-02", 0],
        ["2023-11-03", 4119],
        ["2023-11-04", 5979],
        ["2023-11-05", 737],
        ["2023-11-06", -9100],
        ["2023-11-07", 0],
        ["2023-11-08", -2556],
        ["2023-11-09", -6976],
        ["2023-11-10", 4789],
        ["2023-11-11", -4988],
        ["2023-11-12", 0],
        ["2023-11-13", 4343],
        ["2023-11-14", -384],
        ["2023-11-15", 3989],
        ["2023-11-16", 2057],
        ["2023-11-17", 0],
        ["2023-11-18", -9744],
        ["2023-11-19", 9095],
        ["2023-11-20", 5373],
        ["2023-11-21", -8374],
        ["2023-11-22", 0],
        ["2023-11-23", 2683],
        ["2023-11-24", -1772],
        ["2023-11-25", 2585],
        ["2023-11-26", 6093],
        ["2023-11-27", 0],
        ["2023-11-28", 5213],
        ["2023-11-29", -904],
        ["2023-11-30", -7410],
        ["2023-12-01", 8057],
        ["2023-12-02", 0],
        ["2023-12-03", 5371],
        ["2023-12-04", -6010],
        ["2023-12-05", 9567],
        ["2023-12-06", 5025],
        ["2023-12-07", 0],
        ["2023-12-08", -1218],
        ["2023-12-09", 257],
        ["2023-12-10", 1527],
        ["2023-12-11", 5017],
        ["2023-12-12", 0],
        ["2023-12-13", -7662],
        ["2023-12-14", -9108],
        ["2023-12-15", -590],
        ["2023-12-16", -6492],
        ["2023-12-17", 0],
        ["2023-12-18", -4576],
        ["2023-12-19", 8813],
        ["2023-12-20", -3572],
        ["2023-12-21", -3166],
        ["2023-12-22", 0],
        ["2023-12-23", 959],
        ["2023-12-24", 3223],
        ["2023-12-25", -2526],
        ["2023-12-26", 1051],
        ["2023-12-27", 0],
        ["2023-12-28", 4349],
        ["2023-12-29", 3755],
        ["2023-12-30", 2727],
        ["2023-12-31", 3049],
      ],
      selectedPeriod: "JAN",
    };
  },
  methods: {
    boxColor(item) {
      const [date, value] = item;
      const month = date.split("-")[1];

      if (
        this.selectedPeriod === "ANUAL" ||
        this.listMonths[month - 1] === this.selectedPeriod
      ) {
        if (value > 0) return "bg-ontick-green-600";
        if (value < 0) return "bg-ontick-red-600";
        return "bg-ontick-steel-500";
      }

      if (value > 0) return "bg-ontick-green-600 opacity-20";
      if (value < 0) return "bg-ontick-red-600 opacity-20";
      return "bg-ontick-steel-500 opacity-20";
    },
    boxTooltipContent(item) {
      const date = item[0].split("-").reverse().join("/");
      return `<span class="text-xs"><strong>Data:</strong> ${date} | <strong>Valor:</strong> ${item[1]}</span>`;
    },
    textColorMonth(month) {
      if (this.selectedPeriod === "ANUAL") return "text-gray-50";
      return month === this.selectedPeriod
        ? "text-gray-50"
        : "text-gray-50 opacity-20";
    },
  },
};
</script>

<style lang="scss" scoped>
.cardHeatmap {
  @apply flex border-2 border-ontick-graphite-400 h-56;
  @apply flex flex-col flex-wrap;
  @apply justify-start;
}
.boxHeatmap {
  @apply w-4 h-4 rounded-sm cursor-pointer;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.8);
}
.days,
.months {
  @apply text-xs font-medium flex items-center;
}
.button {
  @apply text-xs font-medium rounded-md;
  @apply bg-ontick-steel-400 px-3 py-1;
}
.active {
  @apply text-white bg-ontick-blue-500;
}
</style>
